export const GET_FILE_REQUIREMENT = "GET_FILE_REQUIREMENT"
export const GET_FILE_REQUIREMENT_SUCCESS = "GET_FILE_REQUIREMENT_SUCCESS"
export const GET_FILE_REQUIREMENT_FAIL = "GET_FILE_REQUIREMENT_FAIL"

export const GET_LIST_AREA = "GET_LIST_AREA"
export const GET_LIST_AREA_SUCCESS = "GET_LIST_AREA_SUCCESS"
export const GET_LIST_AREA_FAIL = "GET_LIST_AREA_FAIL"

export const GET_LIST_FILE_TYPE = "GET_LIST_FILE_TYPE"
export const GET_LIST_FILE_TYPE_SUCCESS = "GET_LIST_FILE_TYPE_SUCCESS"
export const GET_LIST_FILE_TYPE_FAIL = "GET_LIST_FILE_TYPE_FAIL"

export const SAVE_FILE = "SAVE_FILE"
export const SAVE_FILE_SUCCESS = "SAVE_FILE_SUCCESS"
export const SAVE_FILE_FAIL = "SAVE_FILE_FAIL"

export const EDIT_FILE = "EDIT_FILE"
export const EDIT_FILE_SUCCESS = "EDIT_FILE_SUCCESS"
export const EDIT_FILE_FAIL = "EDIT_FILE_FAIL"

export const DELETE_FILE = "DELETE_FILE"
export const DELETE_FILE_SUCCESS = "DELETE_FILE_SUCCESS"
export const DELETE_FILE_FAIL = "DELETE_FILE_FAIL"

export const CLEAN_DATA_FILE = "CLEAN_DATA_FILE"
